import axios from "axios";

export const fetchUserGoalData =
  (token, filter, searchKey, subFilterData = null) =>
  async (dispatch) => {
    dispatch({ type: "FETCH_USER_GOAL_REQUEST" });

    const search = searchKey ? searchKey : "";
    let filter_sub = "";
    let filter_sub_c = "";
    if (subFilterData?.subFilter) {
      filter_sub = subFilterData.subFilter;
    }
    if (subFilterData?.childFilter) {
      filter_sub_c = subFilterData.childFilter;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL_USER}/getAllGoals?filter=${filter}&search=${search}&filter_sub=${filter_sub}&filter_sub_c=${filter_sub_c}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.data?.success) {
        dispatch({
          type: "FETCH_USER_GOAL_SUCCESS",
          payload: response.data,
        });
      } else {
        dispatch({
          type: "FETCH_USER_GOAL_FAILURE",
          payload: response?.data?.message,
        });
      }
    } catch (error) {
      dispatch({ type: "FETCH_USER_GOAL_FAILURE", payload: error.message });
    }
  };

export const fetchUserGoalDataScroll =
  (token, filter, page, searchKey, subFilterData = null) =>
  async (dispatch) => {
    const search = searchKey ? searchKey : "";

    let filter_sub = "";
    let filter_sub_c = "";
    if (subFilterData?.subFilter) {
      filter_sub = subFilterData.subFilter;
    }
    if (subFilterData?.childFilter) {
      filter_sub_c = subFilterData.childFilter;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL_USER}/getAllGoals?filter=${filter}&page=${page}&search=${search}&filter_sub=${filter_sub}&filter_sub_c=${filter_sub_c}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "FETCH_USER_GOAL_SUCCESS_ADD",
        payload: response.data.data,
      });
    } catch (error) {
    }
  };

export const fetchUserGoalDataSearch =
  (token, filter, page, searchKey, subFilterData = null) =>
  async (dispatch) => {
    dispatch({ type: "FETCH_USER_GOAL_SEARCH_REQUEST" });
    const search = searchKey ? searchKey : "";

    let filter_sub = "";
    let filter_sub_c = "";
    if (subFilterData?.subFilter) {
      filter_sub = subFilterData.subFilter;
    }
    if (subFilterData?.childFilter) {
      filter_sub_c = subFilterData.childFilter;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL_USER}/getAllGoals?filter=${filter}&page=${page}&search=${search}&filter_sub=${filter_sub}&filter_sub_c=${filter_sub_c}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "FETCH_USER_GOAL_SEARCH_SUCCESS",
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: "FETCH_USER_GOAL_SEARCH_FAILURE",
        payload: error.message,
      });
    }
  };
